var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-alert',{staticClass:"update-info",attrs:{"show":_vm.alertDismissCountDown,"fade":_vm.fade,"variant":_vm.variant,"dismissible":_vm.dismissible},on:{"dismissed":_vm.handleDismissed}},[_vm._v(" "+_vm._s(_vm.message)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }